import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';

import { SERVER_API_URL } from '@app/app.constants';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private cookieService: CookieService,
    private translateService: TranslateService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const lang =
      this.cookieService.get('lang') ||
      this.translateService.currentLang ||
      this.translateService.getBrowserLang();

    if (isPlatformBrowser(this.platformId)) {
      request = request.clone({
        setHeaders: {
          'Accept-Language': lang === undefined ? 'es' : lang
        },
      });
    }

    if (
      !request ||
      !request.url ||
      (request.url.startsWith('http') &&
        !(SERVER_API_URL && request.url.startsWith(SERVER_API_URL)))
    ) {
      return next.handle(request);
    }

    const token = localStorage.getItem('authenticationToken');
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + token,
          'Accept-Language': lang === undefined ? 'es' : lang
        },
      });
    }
    return next.handle(request);
  }
}
